/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-param-reassign */
import {
    useCallback, useMemo, useContext} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import styles from '../../../SpaAndWellCommonStyles.module.scss'
import metadata from './MachineDetails.metadata.json5';

function MachineDetails(props) {

    const {
        data: machineDetailsVM,
        updateWizardData,
        submissionVM,
        machineDetailsPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);

    const addMacDetails = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            machineDetailsVM.value = machineDetailsVM.value || []

            const { _xCenter, _dtoName } = machineDetailsVM;

            const MacDetailsObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            MacDetailsObjVM.isValidationReq = true;

            machineDetailsVM.pushElement(
                MacDetailsObjVM
            );
            updateWizardData(submissionVM);
        },
        [machineDetailsVM, viewModelService, updateWizardData, submissionVM]
    );

    const handleValueChange = useCallback(
        () => {

            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            machineDetailsVM.value.splice(index, 1);

            _.set(submissionVM.value, machineDetailsPath, machineDetailsVM.value);
            updateWizardData(submissionVM);
        }, [machineDetailsVM.value, submissionVM, machineDetailsPath, updateWizardData]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

             if (path === 'macFie') {
                const value = item.macFie ? item.macFie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.macFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'makFie') {
                const value = item.makFie ? item.makFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.makFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'modFie') {
                const value = item.modFie ? item.modFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.modFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'ageyeaFie') {
                const value = item.ageyeaFie ? item.ageyeaFie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.ageyeaFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'curRepCosinCanFie') {
                const value = item.curRepCosinCanFie ? item.curRepCosinCanFie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.curRepCosinCanFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }
            
        }, [handleValueChange])

    const removeMachineDetailsTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`MachineDetTable`]: {
            data: machineDetailsVM.value,
        }

    }), [machineDetailsVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addMacDetails,
            getTableCell,
            removeMachineDetailsTableRow
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.componentContent,
            machineDetailsVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [machineDetailsVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={machineDetailsVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

MachineDetails.propTypes = wizardProps;
export default withRouter(MachineDetails);
